// extracted by mini-css-extract-plugin
export default {"announcementForm":"index_announcementForm__YKek3"};